/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaterialListRequest
 */
export interface MaterialListRequest {
    /**
     * 
     * @type {string}
     * @memberof MaterialListRequest
     */
    classId: string;
}

/**
 * Check if a given object implements the MaterialListRequest interface.
 */
export function instanceOfMaterialListRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;

    return isInstance;
}

export function MaterialListRequestFromJSON(json: any): MaterialListRequest {
    return MaterialListRequestFromJSONTyped(json, false);
}

export function MaterialListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialListRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
    };
}

export function MaterialListRequestToJSON(value?: MaterialListRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
    };
}

